
<!-- Множественный выбор атрибутов -->

<template>

	<div>

		<b-form-input v-on:input="search" placeholder="Поиск"/>
		
		<b-form-checkbox
            v-model="someSelected"
			:indeterminate="indeterminate"
            aria-describedby="attrs"
            aria-controls="attrs"
			v-on:change="toggleAll"
		>
			Выбрать все
		</b-form-checkbox>

		<div class="mt-2 overflow-auto" style="height:30vh;">
					
			<b-form-checkbox-group :options="current_attrs_visible" v-model="selected_attrs" text-field="name" value-field="id" v-on:change="update" stacked/>

		</div>

		<!--
		<b-button-group class="mt-2 col-12 text-center">

			<b-button variant="outline-primary" v-on:click="check_all()">Выбрать все</b-button>
			<b-button variant="outline-danger" v-on:click="clear_checked()">Очистить выбранные</b-button>

		</b-button-group>
		-->

	</div>

</template>

<script>

export default
{
	props :
	{
		attrs : Array,
		attrs_visible : { type : Array, default : () => [] },
		without_system : Boolean,
		without_bad : Boolean,
	},

	data()
	{
		return {
			
			attrs_all : [],
			selected_attrs : [],
			attrs_ids : [],
			current_attrs_visible : [],
			someSelected: false,
			indeterminate: false,

		}
	},

	watch :
	{
		attrs :
		{
			immediate : true,
			handler(attrs)
			{
				if(this.without_system)
					attrs = attrs.filter(attr => attr.status != "system")

				if(this.without_bad)
					attrs = attrs.filter(attr => attr.key != "attrs.bad")

				var selected = []
				var attrs_visible = this.attrs_visible == null ? [] : this.attrs_visible
				var attrs_ids = []
				var current_attrs_visible = []

				attrs.forEach(
					attr =>
					{
						attrs_ids.push(attr.id)
						current_attrs_visible.push(attr)
				
						if(attrs_visible.find(attr_visible => attr_visible.key == attr.key))
							selected.push(attr.id)
					})

				this.attrs_all = attrs
				this.attrs_ids = attrs_ids
				this.current_attrs_visible = current_attrs_visible
				this.update(selected)
			}
		},

		attrs_visible :
		{
			immediate : true,
			handler(attrs_visible)
			{
				var selected = []
				var attrs = this.attrs_all == null ? [] : this.attrs_all

				attrs.forEach(
					attr =>
					{
						if(attrs_visible.find(attr_visible => attr_visible.key == attr.key))
							selected.push(attr.id)
					})

				this.attrs_visible = attrs_visible
				this.update(selected)
			}
		},
		
		selected_attrs()
                {
                        if (this.selected_attrs.length === 0)
                        {
                                this.indeterminate = false
                                this.someSelected = false
                        }
                        else if (this.selected_attrs.length >= this.attrs.length)
                        {
                                this.indeterminate = false
                                this.someSelected = true
                        }
                        else
                        {
                                this.indeterminate = true
                                this.someSelected = true
                        }
                }
	},

	methods :
	{
		toggleAll(checked)
                {
                        checked ? this.check_all() : this.clear_checked()
                },
		update(value)
		{
			this.selected_attrs = value
			this.$emit("input", value)
			this.sort_current_attrs_visible()
		},

		check_all()
		{
			var attrs_ids = new Set(this.selected_attrs)

			this.current_attrs_visible.forEach(attr => attrs_ids.add(attr.id))
			this.update(Array.from(attrs_ids))
		},

		clear_checked()
		{
			var attrs_ids = this.selected_attrs

			this.current_attrs_visible.forEach(
				attr =>
				{
					const ind = attrs_ids.findIndex(id => id == attr.id)

					if(ind >= 0)
						attrs_ids.splice(ind, 1)
				})

			this.update(attrs_ids)
		},

		search(name)
		{
			if(name == null)
				name = this.attr_name

			const exp = new RegExp(name, "i")

			this.current_attrs_visible = this.attrs_all.filter(elem => ( elem.name.match(exp) || name == null ))
			this.sort_current_attrs_visible()
		},

		sort_current_attrs_visible()
		{
			var current_attrs_visible = this.current_attrs_visible

			current_attrs_visible.forEach(attr => { attr.checked = this.selected_attrs.indexOf(attr.id) >= 0 })
			this.current_attrs_visible = current_attrs_visible.sort(
				( a, b ) =>
				{
					if(a.checked && ! b.checked) return -1
					else if(! a.checked && b.checked) return 1
					else if(a.name > b.name) return 1
					else if(a.name < b.name) return -1

					return 0
				})

		},
	}
}

</script>

